import { createSlice } from "@reduxjs/toolkit";
import { deleteBannersAPI } from "../../actions/banners/deleteBanners";

const initialState = {
  addUser: {},
  loading: false,
  error: null,
};

const deleteBannersSlice = createSlice({
  name: "deleteBanners",
  initialState,
  reducers: {
    deleteUserData: (state, action) => {
      state.addUser = action.payload.userAdded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBannersAPI.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteBannersAPI.fulfilled, (state, action) => {
        state.addUser = action.payload.userDeleted;
        state.loading = false;
      })
      .addCase(deleteBannersAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { deleteUserData } = deleteBannersSlice.actions;
export default deleteBannersSlice.reducer;
